import {
  View,
  Text,
  Image,
  Dimensions,
  TouchableOpacity,
  TextInput,
  KeyboardAvoidingView,
  FlatList,
} from "react-native";
import React, { useEffect, useState } from "react";
import MyView from "../../components/custom/MyView";
import {
  gray,
  kalbasiMaybe,
  lightBlue,
  lighterBlue,
  primary,
  success,
  white,
} from "../../colors";
import { consultationDoctor, kidsWithDoctor } from "../../imports";
import MyText from "../../components/custom/MyText";
import { RefreshControl, ScrollView } from "react-native-gesture-handler";
import WelcomeUser from "../../components/home/WelcomeUser";
import translate from "../../functions/translate";
import Wallet from "../../components/home/Wallet";
import GrowTest from "../../components/home/GrowTest";
import ASQ3Test from "../../components/home/ASQ3Test";
import ASQSE2Test from "../../components/home/ASQSE2Test";
import ADHDTest from "../../components/home/ADHDTest";
import LearningSlider from "../../components/home/LearningSlider";
import { useDispatch, useSelector } from "react-redux";
import {
  changeHeaderColor,
  showBackButtonWithFunction,
} from "../../redux/header/headerAction";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import SelectIcon from "../../assets/svg/SelectIcon";
import MyButton from "../../components/custom/MyButton";
import { LinearGradient } from "expo-linear-gradient";
import SectionDropdown from "../../components/custom/SectionDropdown";
import { AntDesign } from "@expo/vector-icons";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import Dropdown from "../../components/custom/Dropdown";
import DoctorCard from "../../components/consultation/DoctorCard";
import { refresh } from "../../redux/main/mainAction";
import getListOfDoctors from "../../api/consultation/getListOfDoctors";
import getListOfExpertise from "../../api/consultation/getListOfExpertise";

export default function Consultation({ route }) {
  const { params } = route;
  const dispatch = useDispatch();
  const main = useSelector((store) => store.main);
  const navigation = useNavigation();
  const [doctors, setDoctors] = useState([]);
  const [searchButton, searchButtonChanged] = useState(true);
  const [expertiseList, setExpertise] = useState([
    { nameEn: "", nameFa: "همه" },
  ]);
  const [searchDetail, setSearchDetail] = useState({
    searchKey: "",
    expertise: "",
  });

  const isFocused = useIsFocused();
  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor(lighterBlue));
      dispatch(showBackButtonWithFunction(() => navigation.goBack()));
    }
  }, [isFocused]);

  useEffect(() => {
    getListOfDoctors(searchDetail.expertise, searchDetail.searchKey)
      .then(({ data }) => {
        if (data.status === 200) {
          setDoctors(data.data);
        }
      })
      .catch((error) => {});
  }, [main.refresh, searchDetail, searchButton]);

  useEffect(() => {
    getListOfExpertise().then(({ data }) => {
      if (data.status === 200) {
        setExpertise([...data.data, { nameEn: "", nameFa: "همه" }]);
      }
    });
  }, []);

  return (
    <KeyboardAwareScrollView
      enableOnAndroid
      extraHeight={100}
      refreshControl={
        <RefreshControl
          refreshing={false}
          onRefresh={() => {
            dispatch(refresh());
          }}
        />
      }
    >
      <View style={{ alignItems: "center" }}>
        <View style={{ alignItems: "center" }}>
          <View style={{ backgroundColor: lighterBlue }}>
            <View
              style={{
                backgroundColor: lighterBlue,
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10,
                width: Dimensions.get("screen").width,
                minHeight: 150,
                flexDirection: "row",
                paddingHorizontal: 10,
              }}
            >
              <View style={{ flex: 5 }}>
                <View>
                  <MyText
                    style={{
                      fontSize: 28,
                      marginHorizontal: 10,
                      color: "#504E4E",
                    }}
                  >
                    {translate("consultation and help")}
                  </MyText>
                </View>
                <View
                  direction={main.rtl ? "rtl" : "ltr"}
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: 10,
                  }}
                >
                  <View
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: 20,
                      backgroundColor: "white",
                      marginHorizontal: 10,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Image
                      source={{ uri: params.childImage }}
                      style={{ width: 38, height: 38, borderRadius: 20 }}
                    />
                  </View>
                  <View>
                    <MyText
                      style={{
                        fontWeight: "bold",
                        fontSize: 16,
                        marginBottom: 5,
                      }}
                    >
                      {params.childName}
                    </MyText>
                    <View style={{ flexDirection: "row" }}>
                      <MyText style={{ fontSize: 9 }}>
                        {params.childGender === "male"
                          ? translate("your son")
                          : translate("your daughter")}
                      </MyText>
                      <MyText style={{ fontSize: 9, marginHorizontal: 2 }}>
                        {params.childName}
                      </MyText>
                      {/* <MyText style={{ fontSize: 9 }}>
                        {translate("has #only english")}
                      </MyText>
                      <MyText style={{ fontSize: 9, marginRight: 2 }}>2</MyText>
                      <MyText style={{ fontSize: 9 }}>
                        {translate("years old")}
                      </MyText> */}
                    </View>
                  </View>
                </View>
                {/* <View
                  style={{
                    flexDirection: "row",
                    width: "100%",
                    justifyContent: "center",
                    marginTop: 10,
                    top: 10,
                  }}
                >
                  <MyButton
                    style={{ paddingHorizontal: 10, borderRadius: 15 }}
                    textStyle={{ fontSize: 13 }}
                    text={`${translate("choose doctor for")} ${
                      params.childName
                    }`}
                  />
                </View> */}
              </View>
              <View style={{ flex: 3 }}>
                <Image
                  source={consultationDoctor}
                  style={{ width: "75%", height: 200 }}
                  resizeMode="contain"
                />
              </View>
            </View>
            <TouchableOpacity
              onPress={() => navigation.navigate("SelectChildren")}
              style={{
                flexDirection: "row",
                marginHorizontal: 20,
                marginBottom: 5,
                alignItems: "center",
              }}
            >
              <View style={{ flex: 1 }}></View>
              <View style={{ marginHorizontal: 5 }}>
                <SelectIcon />
              </View>
              <MyText style={{ color: "#a7a7a7" }}>
                {translate("choose another children")}
              </MyText>
            </TouchableOpacity>
          </View>
        </View>
        <LinearGradient
          style={{ width: "100%", height: 2 }}
          colors={[
            "#ECC9C5",
            "#ECC9C5",
            "#bbeFFF",
            "#CBE9FF",
            "#CBE9FF",
            "#CBE9FF",
          ]}
          start={{ y: 0.5, x: 0 }}
          end={{ y: 0.5, x: 1 }}
        />

        <View
          style={{ flexDirection: "row", paddingHorizontal: 10, width: "100%" }}
        >
          <SectionDropdown
            headerElement={
              <FlatList
                style={{ marginTop: 5, width: "95%" }}
                horizontal
                enableOnAndroid
                showsHorizontalScrollIndicator={false}
                data={expertiseList}
                renderItem={({ item }) => (
                  <TouchableOpacity
                    onPress={() => {
                      setSearchDetail((prev) => ({
                        ...prev,
                        expertise: item.nameEn,
                      }));
                    }}
                    style={{
                      padding: 2,
                      borderRadius: 10,
                      paddingHorizontal: 10,
                      borderColor: primary,
                      borderWidth: 1,
                      backgroundColor:
                        searchDetail.expertise === item.nameEn ? white : null,
                      marginHorizontal: 3,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <MyText
                      style={{
                        color:
                          searchDetail.expertise === item.nameEn
                            ? primary
                            : gray,
                      }}
                    >
                      {item.nameFa}
                    </MyText>
                  </TouchableOpacity>
                )}
              />
            }
            backgroundColor={lightBlue}
            title={translate("search by name")}
          >
            <View style={{ alignItems: "center" }}>
              <View
                style={{
                  flexDirection: "row",
                  borderRadius: 15,
                  backgroundColor: white,
                  width: "95%",
                }}
              >
                <TextInput
                  onChangeText={(text) =>
                    setSearchDetail((prev) => ({
                      ...prev,
                      searchKey: text,
                    }))
                  }
                  style={{ flex: 10, height: 40, paddingHorizontal: 10 }}
                />
                <TouchableOpacity
                  onPress={() => searchButtonChanged(!searchButton)}
                  style={{
                    flex: 3,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <AntDesign name="search1" size={24} color="black" />
                </TouchableOpacity>
              </View>
            </View>
          </SectionDropdown>

          {/* <View style={{ flex: 0.4 }}></View>
          <View style={{ flex: 5 }}>
            <SectionDropdown
              title={translate("specialties")}
              textColor={white}
              backgroundColor={kalbasiMaybe}
            >
              <View style={{ marginTop: 5, alignItems: "center" }}>
                {expertiseList.map((expertise, index) => (
                  <TouchableOpacity
                    key={index}
                    onPress={() => {
                      setSearchDetail((prev) => ({
                        ...prev,
                        expertise: expertise.nameEn,
                      }));
                    }}
                    style={{ marginBottom: 5 }}
                  >
                    <MyText
                      style={{
                        color:
                          searchDetail.expertise === expertise.nameEn
                            ? primary
                            : gray,
                      }}
                    >
                      {expertise.nameFa}
                    </MyText>
                  </TouchableOpacity>
                ))}
              </View>
            </SectionDropdown>
          </View> */}
        </View>
        <View style={{ marginTop: 10, width: "94%" }}>
          {doctors.length <= 0 && (
            <View
              style={{ width: "100%", alignItems: "center", marginTop: 20 }}
            >
              <MyText style={{ fontSize: 20, color: gray }}>
                {translate("there is no item")}
              </MyText>
            </View>
          )}
          {doctors.map((doctor) => (
            <DoctorCard
              active={+doctor.countActiveCounseling < +doctor.maxCounseling}
              key={doctor.id}
              expertise={doctor.expertise}
              name={doctor.name}
              lastName={doctor.lastName}
              image={doctor.picURL}
              consultationCount={doctor.countCounseling}
              price={doctor.price}
              childId={params.childId}
              id={doctor.id}
            />
          ))}
        </View>
      </View>
      <View style={{ height: 100 }}></View>
    </KeyboardAwareScrollView>
  );
}
